import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { CONTACTS, MAILTO } from "../mock";

const Section = ({ n, title, children }) => (
  <section className="border-t border-[var(--cm-line)] pt-8">
    <p className="font-mono-cm text-[0.68rem] uppercase tracking-[0.12em] text-[#9a9a92]">
      <span className="text-[var(--cm-green)]">{n}</span> {title}
    </p>
    <div className="mt-4 space-y-3 text-[0.95rem] leading-relaxed text-[#4a4a45]">
      {children}
    </div>
  </section>
);

export default function Privacy() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <>
      <Header />
      <main className="pb-24 pt-[100px] lg:pt-[120px]" data-testid="privacy-page">
        <div className="mx-auto max-w-[860px] px-6 lg:px-10">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-[0.85rem] text-[#6f6f68] transition-colors hover:text-[var(--cm-ink)]"
          >
            <ArrowLeft size={15} /> Torna alla home
          </Link>

          <p className="label-mono mb-4 mt-8">Informativa privacy</p>
          <h1 className="h-display text-[clamp(1.9rem,4vw,3rem)]">Privacy Policy</h1>
          <p className="mt-4 text-[0.95rem] text-[#6f6f68]">
            Ultimo aggiornamento: giugno 2026. La presente informativa descrive come
            trattiamo i dati personali raccolti tramite il sito www.carmaps.it, ai sensi
            del Regolamento (UE) 2016/679 (GDPR) e del D.lgs. 196/2003.
          </p>

          <div className="mt-12 space-y-12">
            <Section n="01" title="Titolare del trattamento">
              <p>
                Carmaps — Corso Francia 115, 10093 Collegno (TO). P. IVA {CONTACTS.piva} ·
                RUI {CONTACTS.rui}. Per qualsiasi richiesta relativa ai tuoi dati puoi
                scrivere a{" "}
                <a href={MAILTO} className="underline underline-offset-2 hover:text-[var(--cm-ink)]">
                  {CONTACTS.email}
                </a>{" "}
                o telefonare al {CONTACTS.ufficio}.
              </p>
            </Section>

            <Section n="02" title="Dati che raccogliamo">
              <p>Trattiamo esclusivamente i dati che ci fornisci volontariamente tramite i moduli del sito:</p>
              <ul className="list-disc space-y-1 pl-5">
                <li>Nome e recapiti (telefono ed email) inseriti nelle richieste di informazioni, valutazione o prenotazione.</li>
                <li>Il messaggio e i riferimenti del veicolo di interesse.</li>
                <li>Dati necessari alla gestione di un'eventuale prenotazione con deposito.</li>
              </ul>
              <p>Non raccogliamo categorie particolari di dati e non effettuiamo profilazione automatizzata.</p>
            </Section>

            <Section n="03" title="Finalità e base giuridica">
              <ul className="list-disc space-y-1 pl-5">
                <li>Rispondere alle tue richieste e ricontattarti (esecuzione di misure precontrattuali su tua richiesta).</li>
                <li>Gestire la prenotazione del veicolo e l'eventuale deposito (esecuzione di un contratto).</li>
                <li>Adempiere agli obblighi di legge, fiscali e amministrativi (obbligo legale).</li>
              </ul>
            </Section>

            <Section n="04" title="Destinatari dei dati">
              <p>
                I dati possono essere trattati da fornitori che ci supportano nell'erogazione
                del servizio, in qualità di responsabili del trattamento: la piattaforma CRM
                che utilizziamo per gestire i contatti e il servizio di invio email. Non
                vendiamo né cediamo i tuoi dati a terzi per finalità di marketing.
              </p>
            </Section>

            <Section n="05" title="Conservazione">
              <p>
                Conserviamo i dati per il tempo necessario a gestire la tua richiesta e, in caso
                di rapporto contrattuale, per il periodo previsto dagli obblighi di legge.
                Trascorsi tali termini i dati vengono cancellati o resi anonimi.
              </p>
            </Section>

            <Section n="06" title="I tuoi diritti">
              <p>
                Puoi in ogni momento richiedere l'accesso, la rettifica, la cancellazione, la
                limitazione o la portabilità dei tuoi dati, nonché opporti al trattamento,
                scrivendo a{" "}
                <a href={MAILTO} className="underline underline-offset-2 hover:text-[var(--cm-ink)]">
                  {CONTACTS.email}
                </a>. Hai inoltre il diritto di proporre reclamo al Garante per la protezione
                dei dati personali (www.garanteprivacy.it).
              </p>
            </Section>

            <Section n="07" title="Cookie">
              <p>
                Il sito utilizza cookie tecnici necessari al suo funzionamento. Eventuali cookie
                di terze parti (es. mappe o video incorporati) vengono attivati solo quando
                interagisci con i relativi contenuti.
              </p>
            </Section>
          </div>

          <p className="mt-14 text-[0.85rem] text-[#9a9a92]">
            Vedi anche le nostre{" "}
            <Link to="/condizioni" className="underline underline-offset-2 hover:text-[var(--cm-ink)]">
              Condizioni di vendita e prenotazione
            </Link>.
          </p>
        </div>
      </main>
      <Footer />
    </>
  );
}
